import { shallowRef, computed, nextTick } from 'vue';
import { useModalOverlayStore } from '@nuxt-common/atomic-ui/app/stores/useModalOverlayStore';
/** @import { ModalObject, IModal } from '@/types/definitions'; */

/**
 *
 * @returns {IModal}
 */
export function useModal() {
  const modals = useState('modal', () => shallowRef([]));
  const modalOverlayStore = useModalOverlayStore();

  /**
   *
   * @param {ModalObject} modalObj
   * @returns {void} - This function does not return anything
   */
  function showModal(modalObj) {
    modals.value = [...modals.value, modalObj];

    nextTick(() => {
      modalOverlayStore.setModalOverlayVisibility(modalObj.id);
    });
  }

  /**
   *
   * @param {string} id - Id selector of modal that is supposed to be closed
   * @returns {void} - This function does not return anything
   */
  function closeModal(id) {
    const filtered = modals.value.filter((_modal) => _modal.id !== id);
    modals.value = [...filtered];
  }

  const modal = computed(() => modals.value[0]);

  return {
    showModal,
    closeModal,
    modal,
    modals,
    isModalAvailable: computed(() => !!modal.value),
  };
}

export default useModal;
